<script>

import {SpeakerMixin} from "../lib/speaker-utils.js"
import Favorite from "../lib/favorite.vue"

export default {
  mixins: [SpeakerMixin],
  components: {Favorite},
  props: {
    speaker: {type: Object, required: true},
  },
}

</script>

<template>

  <div class="card mb-2 p-2">
    <router-link :to="speakerUrl(speaker)" class="text-center">
      <favorite attr="speaker" :value="speaker.content_code" :obj="speaker"
       @favorite-changed="$emit('favorite-changed', $event)" style="float:left" />
      <img :src="speaker.profile_img_url" class="avatar" />
      <div class="card-body text-center">
        <h4 class="card-title mb-0">{{speakerFullName(speaker)}}</h4>
        <p v-if="speaker.job_title" class="text-muted">
          <small>{{speaker.job_title}}</small>
          <small v-if="speaker.sessions_chaired.length"><br>Moderator:in</small>
        </p>
        <div v-if="speaker.company">{{speaker.company}}</div>
      </div>
    </router-link>
  </div>

</template>

<style scoped>

a { text-decoration:none}

.card {
  width: 10.7rem;
}

.avatar {
  height:100px;
  width:100px;
  object-fit:cover;
  border-radius:50%;
  overflow:hidden;
}

</style>